module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "max-width": "800px",
      "margin": "0 auto"
    }
  }, [(_vm.componentLoaded) ? _c('div', {
    staticClass: "text-center text-white push-30"
  }) : _vm._e(), _vm._v(" "), (_vm.componentLoaded) ? _c("inspection-template", {
    tag: "component",
    attrs: {
      "inspection": _vm.inspection
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02191a94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/published.vue
// module id = 811
// module chunks = 3